import type { InputDescription } from "@smartsuite/automation-engine-api";

export const withRequired = (description: InputDescription): boolean =>
  (description.editor?.editor.oneofKind === "jsonStructure" &&
    description.editor.editor.jsonStructure.withRequired === true) ||
  (description.editor?.editor.oneofKind === "keyValue" &&
    description.editor.editor.keyValue.withRequired === true);
